import {
  Box,
  Stack
} from '@mui/material';
import { useAuthStateQuery } from 'generated/graphql';
import _ from 'lodash';
import { useEffect } from 'react';
import {
  Outlet,
  useLocation,
  useNavigate
} from 'react-router-dom';

import { useContinueNavState } from 'modules/common';
import backgroundImage from '../../assets/auth/authBgImage.png';


export type AuthLayoutProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const AuthLayout = (props: AuthLayoutProps) => {
  const continueState = useContinueNavState();

  const queryTuple = useAuthStateQuery();
  const navigate = useNavigate();
  const location = useLocation();



  useEffect(() => {
    const isSignedIn = queryTuple.data?.authQuery?.authStatus === 'signedIn';
    if (isSignedIn) {
      const state = location.state;
      // The continue value is used when the user enters the app from a QR Code URL.
      const continueVal
        = continueState?.continueValue // Available when user is already logged in.
        ?? state?.continueValue; // Available when  user clicked "Log In" from register
      if (_.isString(continueVal)) {
        navigate(continueVal);
      } else {
        navigate('/organization/projects');
      }
    }
  }, [
    continueState?.continueValue,
    location,
    navigate,
    queryTuple.data?.authQuery?.authStatus
  ]);



  return (
    <Box
      display='flex'
      flexDirection='row'
      flex='1 1 0'
      columnGap='1rem'
      marginTop='1rem'
      marginBottom='-2rem'
      paddingX={{
        xs: 0,
        sm: '1rem'
      }}
    >
      <Box
        sx={{
          display: {
            xs: 'none',
            md: 'initial'
          }
        }}
        component='img'
        src={backgroundImage}
        maxWidth='50%'
        height='calc(100vh - 2rem)'
      />

      <Stack
        sx={{
          background: 'linear-gradient(0deg, rgba(2, 0, 67, 0.00) 72.6%, rgba(2, 0, 67, 0.02) 99.87%), var(--Supporting-white, #FFF)',
          flex: 1
        }}
        justifyContent='stretch'
        alignItems='stretch'
        borderRadius='1.5rem'
        border='6px solid white'
        direction='column'
        paddingX={{
          sm: '4rem',
          xs: '1rem'
        }}
        paddingY='2rem'
        rowGap='1.5rem'
      >

        <Outlet />
      </Stack>
    </Box>

  );
};
